"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNKNOWN_ENV = exports.LOCAL_ENV = exports.LOAD_ENV = exports.DEV_ENV = exports.BETA_ENV = exports.STAGING_ENV = exports.PROD_ENV = void 0;
const getAppHostConfig_1 = __importDefault(require("./getAppHostConfig"));
const PROD_ENV = 'prod';
exports.PROD_ENV = PROD_ENV;
const STAGING_ENV = 'staging';
exports.STAGING_ENV = STAGING_ENV;
const BETA_ENV = 'beta';
exports.BETA_ENV = BETA_ENV;
const DEV_ENV = 'dev';
exports.DEV_ENV = DEV_ENV;
const LOAD_ENV = 'load';
exports.LOAD_ENV = LOAD_ENV;
const LOCAL_ENV = 'local';
exports.LOCAL_ENV = LOCAL_ENV;
const UNKNOWN_ENV = 'unknown';
exports.UNKNOWN_ENV = UNKNOWN_ENV;
exports.default = () => {
    const { BASE_HOST } = getAppHostConfig_1.default();
    if (BASE_HOST === 'atms.a2z.com') {
        return PROD_ENV;
    }
    else if (BASE_HOST === 'staging.atms.a2z.com') {
        return STAGING_ENV;
    }
    else if (BASE_HOST === 'beta2.atms.a2z.com') {
        return BETA_ENV;
    }
    else if (BASE_HOST === 'dev.atms.a2z.com') {
        return DEV_ENV;
    }
    else if (BASE_HOST === 'load.atms.a2z.com') {
        return LOAD_ENV;
    }
    else if (BASE_HOST === 'local.atms.a2z.com') {
        return LOCAL_ENV;
    }
    else {
        return UNKNOWN_ENV;
    }
};
//# sourceMappingURL=inferEnvironment.js.map